import { FaTrash } from "react-icons/fa";
import Upload from "../../../Components/upload";

const FormFields = ({ cards, setFieldValue, handleRemoveItem }) => {
  return (
    <>
      {cards.map((item, index) => (
        <div key={index} className="card mt-3 p-3">
          <div className="row g-3">
            <div className="col-12 col-md-4">
              <Upload
                label={`card-slider-${index}`}
                apiUrl="uploads?label=layout"
                initialImage={item.image}
                onChange={(url) => {
                  const updated = [...cards];
                  updated[index].image = url;
                  setFieldValue("data", updated);
                }}
              />
            </div>

            <div className="col-12 col-md-4">
              <input
                type="text"
                placeholder="Link"
                className="form-control border border-dark"
                value={item.link}
                onChange={(e) => {
                  const updated = [...cards];
                  updated[index].link = e.target.value;
                  setFieldValue("data", updated);
                }}
              />
            </div>

            <div className="col-12 col-md-4">
              <input
                type="text"
                placeholder="Button Text"
                className="form-control border border-dark"
                value={item.buttonText}
                onChange={(e) => {
                  const updated = [...cards];
                  updated[index].buttonText = e.target.value;
                  setFieldValue("data", updated); 
                }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-danger btn-sm mt-2"
              onClick={() => handleRemoveItem(index)}
            >
              <FaTrash />
            </button>
          </div>
        </div>
      ))}
    </>
  );
};

export default FormFields;
